<template>
  <div class="section-wrapper d-flex">
    <div class="temporary-bg"></div>
    <div class="left-side">
      <h1>
        AGD<br />
        <strong>
          Zaprojektowane<br />
          po ludzku
        </strong>
      </h1>
    </div>
    <div class="right-side">
      <img :src="logoUrl" alt="">
    </div>
    <div id="trigger"></div>
  </div>
</template>

<script>
export default {
  computed: {
    logoUrl: function () {
      return window.pageContentData.params.images['logo-zpl']
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-wrapper {
    width: 100%;
    height: calc(100vh - 140px);
    // height: 100vh;
    // background: -webkit-gradient(linear,left top,right top,from(#ae0b11),to(#e41429));
    // background: linear-gradient(90deg,#ae0b11,#e41429);
    position: relative;
    // z-index: -1;

    @media only screen and (max-width : 1024px) {
      max-height: 43.64vw;
      height: calc(100vh - 140px);
      background: -webkit-gradient(linear,left top,right top,from(#ae0b11),to(#e41429));
      background: linear-gradient(90deg,#ae0b11,#e41429);
    }

    .temporary-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background: url('../../../assets/images/zpl/kobieta-sec-1.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      z-index: 1;
      pointer-events: none;
      display: none;
      

      @media only screen and (max-width : 1024px) {
        display: block;
      }
    }

    .left-side {
      height: 100%;
      width: 50%;
      
      h1 {
        font-size: 3.9vw;
        font-weight: 400;
        color: #fff;
        line-height: 5vw;

        padding-top: 20%;
        margin-left: 8.3333vw;

        strong {
          font-weight: 700;
        }
      }
    }

    .right-side {
      background: url('../../../assets/images/zpl/img-sec-7-piekarnik.png');
      background-repeat: no-repeat;
      background-position: 0% 0%;
      background-size: contain;
      height: 100%;
      width: 50%;
      position: relative;
      z-index: 0;

      img {
        position: absolute;
        bottom: 4vw;
        right: 8.3333vw;
        max-width: 16vw;
      }
    }
  }
</style>
